import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { SapEccResourceDataset } from 'app/model/dataset/sap-ecc-resource.dataset';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapEccResourceDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                path: '*'
            }
        }
    }
})
export class SapEccResourceDatasetAdapter extends TabularTypeDatasetAdapter<SapEccResourceDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SapEccResourceDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(SapEccResourceDataset).name, 'path');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SapEccResourceDataset): Promise<SapEccResourceDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, SapEccResourceDataset.MODEL, 'path');
    }
}
